/* lang-srs.js — spaced-repetition scheduling (SM-2) for Timbrica
 * language tools. Pure functions, no I/O — fully node-testable.
 *
 * Card state is the caller's to persist (localStorage per tool).
 * Ease is in Anki per-mille units (2500 = 250%) so exported decks behave
 * consistently. Exposes window.LangSRS + module.exports.
 */
(function (root, factory) {
  'use strict';
  var L = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = L;
  if (typeof window !== 'undefined') window.LangSRS = L;
  else if (root) root.LangSRS = L;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var DAY = 86400000;
  var MIN_EASE = 1300;

  function newCard(now) {
    now = now || Date.now();
    return { reps: 0, ivl: 0, ease: 2500, lapses: 0, due: now, last: 0 };
  }

  /* grade: 0 again · 1 hard · 2 good · 3 easy */
  function schedule(card, grade, now) {
    now = now || Date.now();
    var c = {
      reps: card.reps | 0, ivl: card.ivl | 0, ease: card.ease || 2500,
      lapses: card.lapses | 0, due: card.due || now, last: now
    };
    if (grade <= 0) {
      c.reps = 0;
      c.ivl = 0;
      c.lapses += 1;
      c.ease = Math.max(MIN_EASE, c.ease - 200);
      c.due = now;                              // relearn now
      return c;
    }
    if (grade === 1) {                          // hard
      c.ivl = Math.max(1, Math.round((c.ivl || 1) * 1.2));
      c.ease = Math.max(MIN_EASE, c.ease - 150);
    } else if (grade === 2) {                   // good
      c.ivl = c.reps === 0 ? 1 : c.reps === 1 ? 6 : Math.round(c.ivl * c.ease / 1000);
    } else {                                    // easy (>=3)
      var base = c.reps === 0 ? 1 : c.reps === 1 ? 6 : Math.round(c.ivl * c.ease / 1000);
      c.ivl = Math.round(base * 1.3);
      c.ease = c.ease + 150;
    }
    c.reps += 1;
    c.ivl = Math.max(1, c.ivl);
    c.due = now + c.ivl * DAY;
    return c;
  }

  function isDue(card, now) {
    now = now || Date.now();
    return (card.due || 0) <= now;
  }

  function sortDue(cards, now) {
    now = now || Date.now();
    return cards.slice().sort(function (a, b) { return (a.due || 0) - (b.due || 0); });
  }

  /* Map an SRS card to Anki's cards-table scheduling fields. */
  function toAnkiCard(card, crtEpochSec) {
    if (!card || card.reps === 0) {
      return { type: 0, queue: 0, due: 0, ivl: 0, factor: 0, reps: 0, lapses: 0 };
    }
    var dueDay = crtEpochSec
      ? Math.round(((card.due || Date.now()) / 1000 - crtEpochSec) / 86400)
      : 0;
    return {
      type: 2, queue: 2, due: dueDay,
      ivl: card.ivl | 0, factor: card.ease || 2500,
      reps: card.reps | 0, lapses: card.lapses | 0
    };
  }

  return {
    newCard: newCard,
    schedule: schedule,
    isDue: isDue,
    sortDue: sortDue,
    toAnkiCard: toAnkiCard,
    DAY: DAY
  };
});
